<template>
  <div>
    <Drawer title="结账" width="600" :value="showEdit" :mask-closable="true" @on-close="cancelEdit">
      <Card style="margin-top: 5px">
        <Form ref="editForm" :label-width="100" :model="formData">
          <FormItem label="金额" prop="amount">
            <Input v-model="formData.amount" placeholder="" maxlength="100"></Input>
          </FormItem>
          <FormItem label="打款日期" prop="pay_day">
            <Input v-model="formData.pay_day" placeholder="如2022-09-07" maxlength="100"></Input>
          </FormItem>
          <FormItem label="备注" prop="remark">
            <Input v-model="formData.remark" placeholder="" maxlength="100"></Input>
          </FormItem>
          <FormItem label="凭证" prop="proofs">
            <Upload :action="apiPath + '/admin/common/uploadSettleImg'"
                    :on-success="uploadSuccess"
                    :on-error="uploadError"
                    :on-remove="handleRemove"
                    :on-preview="seeImg"
                    :before-upload="beforeUpload"
                    :format="['jpg','jpeg','png']"
                    :max-size="2048"
                    :on-format-error="formatError"
                    :on-exceeded-size="exceededSize"
                    :default-file-list="proofs"
            >
              <Button icon="ios-cloud-upload-outline" type="primary">点击上传</Button>
            </Upload>
          </FormItem>
        </Form>
      </Card>


      <div class="drawer-footer">
        <Button style="margin-right: 8px" @click="cancelEdit">取消</Button>
        <Button type="primary" @click="doSubmit">确定</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
  import config from '@/config/base-config'
  export default {
    name: "doSettle",
    props:{
      showEdit:{
        type:Boolean,
        default: false
      },
      order_id:{
        type:Number,
        default: 0
      }
    },
    data(){
      return {
        apiPath:config.API_PATH,
        formData:{
          station_id:'',
          amount:'',
          remark:'',
          pay_day:'',
        },
        baseInfo:{},
        proofs:[],
        stations: [],
      }
    },
    methods:{
      async getInfo(){
        let res = await this.$commonFun.postProxy('admin/settlement/getInfo',{id:this.id});
        this.stations = res.data.stations
      },
      cancelEdit(){
         this.$emit('cancel-edit')
      },
      async doSubmit(){
        let _self = this;
        this.formData['order_id'] = this.order_id
        this.formData['proofs'] = this.proofs
        let res = await this.$commonFun.postProxy('admin/settlement/edit',this.formData)
        //编辑成功刷新父页面
        this.$commonFun.dealApiResult(res,()=>{
          _self.$emit('settle-success')
          _self.$commonFun.successTip(res.msg,function () {
            // _self.getInfo()
          })
        })
      },
      uploadSuccess(res,file){
        file.url = res.data.url;
        file.name = res.data.url;
        this.proofs.push(res.data.url)
      },
      handleRemove (file) {
        const fileList = this.$refs.upload.fileList;
        this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
        this.proofs.splice(fileList.indexOf(file), 1)
      },
      uploadError(){
        this.$commonFun.errorTip('上传失败请重试')
      },
      formatError(){
        this.$commonFun.errorTip('图片格式不正确 jpg、jpeg、png')
      },
      exceededSize(){
        this.$commonFun.errorTip('图片大小不能超过2M')
      },
      beforeUpload(){
        if (this.proofs.length >= 3){
          this.$commonFun.errorTip('最多只能上传3张图片')
          return false;
        }
      },
      seeImg(file){
        this.$Modal.info({
          // title: title,
          width:800,
          footerHide:true,
          content: `<img src="${file.url}" style="max-width: 500px;max-height: 500px">`
        });
      }

    },
    mounted() {
      this.getInfo()
    },
  }
</script>

<style scoped lang="less">
  .drawer-footer{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
  }

  .info-item{
    >span:nth-child(1){
      min-width: 100px;
      display: inline-block;
      text-align: right;
      letter-spacing: 2px;
      padding: 2px;
    }
    >span:nth-child(2){
      display: inline-block;
      padding-left: 10px;
    }
    .important-word{
      font-weight: bold;
      color: red;
    }
  }

</style>
